import { animations } from '../aidu/animations.js';
import { breakpoints } from '../aidu/breakpoints.js';
import { colors } from '../aidu/colors.js';
import { elevations } from '../aidu/elevations.js';
import { fills } from '../aidu/fills.js';
import { spacingLegacy } from '../aidu/spacingLegacy.js';
import { spacingTokens } from '../aidu/spacingTokens.js';
import { stacking } from '../aidu/stacking.js';
import { typographyTokens } from '../aidu/typographyTokens.js';
export const theme = {
  animations,
  breakpoints,
  colors,
  elevations,
  fills,
  spacingLegacy,
  stacking,
  fontFamily: "'Open Sans', sans-serif",
  typographyTokens,
  spacingTokens
};